// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f2ea2d74","455":"6c6e9700","644":"81cf9653"}[chunkId] + ".chunk.js";
};